export default "__VITE_ASSET__s4v702Fv__"